<div class="container">
    <div fxLayout="row" fxLayoutAlign="space-between">
        <div class="mat-headline-4">
            <ng-content select="[title]"></ng-content>
        </div>
        <div [fxFlex]="'100px'" >
            <ng-content select="[controls]"></ng-content>
        </div>
    </div>
    <div>
        <ng-content select="[description]"></ng-content>
    </div>
    <div fxLayout="row">
        <div [fxFlex]="indentWidth"></div>
        <div [fxFlex]="contentWidth">
            <ng-content></ng-content>
        </div>
    </div>
</div>